import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';

// import { AppBar, Toolbar } from '@material-ui/core';

import logo1 from 'assets/images/ebiTrade_white.png';
import  'assets/css/navbar.css';


const Navbar = props => {
  const { className, ...rest } = props;


  return (
    <nav
      className={"navbar navbar-expand-lg fixed-top navbar-custom " +
        // props.isDark +
        " sticky " +
        "sticky-dark " 
      }
        id="navbar"
      color="primary"
      position="fixed"
    >
      <div className='navbar-brand logo'>
        <RouterLink to="/">
          <img
           className='avatar-md'
            alt="Logo"
            src={logo1}
            style={{ height: "40px", margin: "5px" }}
          />
        </RouterLink>
      </div>
    </nav>
  );
};

Navbar.propTypes = {
  className: PropTypes.string
};

export default Navbar;
